import { Button } from "react-bootstrap";
import { profileLevelSensorTableColumns } from "../../../Common/constants";
import SensorListTable from "./SensorListTable";
import { Link } from 'react-router-dom';

const ProfileBasedSensors = () => {

    const profileId = window.location.pathname.split("/")[4];

    return (
        <>
            <Link to={{ pathname: `/profile/${profileId}` }}>
                <Button size="sm" className="mb-3 p-2 font-weight-bold">Go back to Profile</Button>
            </Link>
            <SensorListTable columns={profileLevelSensorTableColumns} profileId={profileId} />
        </>
    );
}

export default ProfileBasedSensors;